import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { indian_states } from "../../../components/Data/IndianStates";
import { countries } from "../../../components/Data/Countries";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import {
  FaUser,
  FaEnvelope,
  FaLock,
  FaPhone,
  FaIdCard,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUniversity,
  FaTint,
  FaBirthdayCake,
  FaChurch,
  FaUpload,
  FaArrowLeft,
  FaSave,
} from "react-icons/fa";

import GeographicalComponent from "../../../components/GeographicalComponent/GeographicalComponent";

const FamilyAddChild = () => {
  let navigate = useNavigate();
  const [cityOptions, setCityOptions] = useState();
  const [cityStateInput, setCityStateInput] = useState(false);
  const [churchList, setChurchList] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [{ errorLogApi, sanitizeInput, bloodgroupOptions, placeHolderText }] =
    useAtom(gbState);

  const [formData, setFormData] = useState({
    family_name: null,
    first_name: null,
    last_name: null,
    aadhar_card: null,
    social_security_number: null,
    mobile: null,
    email: null,
    gender: null,
    password: null,
    confirm_password: null,
    parent_church_id: null,
    birth_day: null,
    birth_month: null,
    birth_year: null,
    head_of_family: null,
    communicant_member: null,
    date_of_joining: null,
    address: null,
    area: null,
    pin_code: null,
    zipcode: null,
    city: null,
    state: null,
    country: null,
    blood_group: null,
    qualification: null,
    birth_place: null,
    certificate_upload: null,
    church_account_id: null,
  });

  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/churches/`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const churches = response.data.churches;
        setChurchList(
          churches.map((church) => ({
            value: church._id,
            label: church.church_name + " (" + church.city + ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "ChurchList", "/churches");
      });
  }, []);

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const formatSSN = (value) => {
    // Remove all non-digits
    const cleaned = value.replace(/\D/g, "");

    // Format with dashes
    if (cleaned.length >= 9) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(
        5,
        9
      )}`;
    } else if (cleaned.length > 5) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(
        5
      )}`;
    } else if (cleaned.length > 3) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    }
    return cleaned;
  };

  const handleChange = ({ currentTarget: input }) => {
    if (input.name === "family_name") {
      setFormData({
        ...formData,
        [input.name]: input.value,
        last_name: input.value, // Automatically set last name when family name changes
      });
    } else if (input.name === "social_security_number") {
      const formattedSSN = formatSSN(input.value);
      input.value = formattedSSN;
      setFormData({
        ...formData,
        [input.name]: formattedSSN,
      });
    } else {
      setFormData({
        ...formData,
        [input.name]: input.value,
      });
    }
  };

  const indianStates = Object.keys(indian_states);
  const indianStatesOption = indianStates.map((data) => ({
    value: data,
    label: data,
  }));

  const inputElementWidthStyle = `w-full p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md`;

  const countriesOption = countries.map((country) => ({
    value: country.code,
    label: country.name,
  }));

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "nonbinary", label: "Non-binary" },
    { value: "other", label: "Other" },
  ];

  const dayOptions = Array.from({ length: 31 }, (_, i) => {
    const day = (i + 1).toString().padStart(2, "0");
    return { value: day, label: day };
  });

  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const binaryOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const handleFamilyRegistration = () => {
    // Validate required fields with friendly messages
    const requiredFields = {
      family_name: "a family name",
      first_name: "the first name",
      last_name: "the last name",
      mobile: "a valid mobile number",
      gender: "the gender",
      parent_church_id: "the parent church",
      head_of_family: "the head of family status",
      communicant_member: "the communicant member status",
      country: "the country",
      address: "the address",
    };

    // Check required fields with friendly messages
    for (const [field, label] of Object.entries(requiredFields)) {
      if (!formData[field]) {
        toast.error(`Please enter ${label} to continue`);
        return;
      }
    }

    //Validation cannot continuew without password
    if (!formData.password) {
      toast.error("Please enter a password to continue");
      return;
    }

    // Validate password match with friendly message
    if (formData.password && formData.password !== formData.confirm_password) {
      toast.error("The passwords you entered don't match. Please try again.");
      return;
    }

    // Validate password strength
    if (formData.password) {
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{6,}$/;
      if (!passwordRegex.test(formData.password)) {
        toast.error(
          "Password must contain at least 6 characters, including one uppercase letter, one lowercase letter, one number, and one special character"
        );
        return;
      }
    }

    // Validate date of birth with friendly message
    if (!formData.birth_day || !formData.birth_month) {
      toast.error("Please select both the birth day and month to continue");
      return;
    }

    // Validate email format if provided with friendly message
    if (
      formData.email &&
      !formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
    ) {
      toast.error(
        "The email address format is invalid. Please enter a valid email address"
      );
      return;
    }

    // Validate mobile number format with friendly message
    if (!formData.mobile.match(/^\d{10}$/)) {
      toast.error(
        "Please enter a valid 10-digit mobile number without spaces or special characters"
      );
      return;
    }

    // Validate SSN format if provided
    if (
      formData.social_security_number &&
      !formData.social_security_number.match(/^\d{3}-\d{2}-\d{4}$/)
    ) {
      toast.error(
        "Please enter a valid Social Security Number in XXX-XX-XXXX format"
      );
      return;
    }

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/family/add`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData, certificate_upload: selectedImage },
    };

    axios(config)
      .then(function (response) {
        toast.success("Family member added successfully");
        navigate("/families");
      })
      .catch(function (error) {
        // More user-friendly error messages
        console.log(error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "An error occurred while creating the family member";
        toast.error(errorMessage);
        // toast.error(error?.response?.data?.error?.details[0].message);
        errorLogApi(error, "FamilyAddChild", "/family/add");
      });
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#F9FAFB",
      borderColor: "#D1D5DB",
      "&:hover": {
        borderColor: "#3B82F6",
      },
    }),
  };

  return (
    <div className="w-full min-h-screen p-0">
      <div className="p-8 mx-auto">
        <div className="flex flex-col items-center justify-between mb-8 sm:flex-row">
          <h1 className="mb-4 text-3xl font-bold text-gray-800 sm:mb-0">
            Register Family
          </h1>
          <button
            className="flex items-center px-4 py-2 text-sm text-white transition duration-300 ease-in-out bg-gray-600 rounded-md hover:bg-gray-700"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="mr-2" /> Back
          </button>
        </div>

        <form className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Family Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="family_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter family name"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              First Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="first_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter first name"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Last Name
            </label>
            <div className="relative">
              <FaUser className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="last_name"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter last name"
                value={formData.last_name || ""}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Date of Birth
            </label>
            <div className="flex space-x-2">
              <Select
                name="birth_month"
                onChange={dropDownChange}
                options={monthOptions}
                className="w-1/3"
                placeholder="Month"
                styles={selectStyles}
              />
              <Select
                name="birth_day"
                onChange={dropDownChange}
                options={dayOptions}
                className="w-1/3"
                placeholder="Day"
                styles={selectStyles}
              />
              <DatePicker
                className="w-1/3 h-[38px] bg-gray-50 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                name="birth_year"
                onChange={(date, dateString) => {
                  setFormData({
                    ...formData,
                    birth_year: dateString,
                  });
                }}
                picker="year"
                placeholder="Year"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Gender
            </label>
            <Select
              name="gender"
              onChange={dropDownChange}
              options={genderOptions}
              className="w-full"
              placeholder="Select Gender"
              styles={selectStyles}
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Social Security Number
            </label>
            <div className="relative">
              <FaIdCard className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="social_security_number"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter SSN number"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Mobile
            </label>
            <div className="relative">
              <FaPhone className="absolute text-gray-400 top-3 left-3" />
              <input
                type="tel"
                name="mobile"
                onChange={handleChange}
                pattern="[0-9]*"
                inputMode="numeric"
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter mobile number"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Email
            </label>
            <div className="relative">
              <FaEnvelope className="absolute text-gray-400 top-3 left-3" />
              <input
                type="email"
                name="email"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter email address"
                autoComplete="off"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute text-gray-400 top-3 left-3" />
              <input
                type="password"
                name="password"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter password"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Confirm Password
            </label>
            <div className="relative">
              <FaLock className="absolute text-gray-400 top-3 left-3" />
              <input
                type="password"
                name="confirm_password"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Confirm password"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Head of Family
            </label>
            <Select
              name="head_of_family"
              onChange={dropDownChange}
              options={binaryOptions}
              className="w-full"
              placeholder="Select Head of Family"
              styles={selectStyles}
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Communicant Member
            </label>
            <Select
              name="communicant_member"
              onChange={dropDownChange}
              options={binaryOptions}
              className="w-full"
              placeholder="Select Communicant Member"
              styles={selectStyles}
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Parent Church
            </label>
            <Select
              name="parent_church_id"
              onChange={dropDownChange}
              options={churchList}
              className="w-full"
              placeholder="Select Parent Church"
              styles={selectStyles}
            />
          </div>
          <GeographicalComponent
            setFormData={setFormData}
            formData={formData}
            handleChange={handleChange}
            dropDownChange={dropDownChange}
            style={style}
            placeHolderText={placeHolderText}
          />
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Address
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="address"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter address"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Area
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="area"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter area"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Zip code
            </label>
            <div className="relative">
              <FaMapMarkerAlt className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="zipcode"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter zipcode"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Qualification / Job Profile
            </label>
            <div className="relative">
              <FaUniversity className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="qualification"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter qualification"
              />
            </div>
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Blood Group
            </label>
            <Select
              name="blood_group"
              onChange={dropDownChange}
              options={bloodgroupOptions}
              className="w-full"
              placeholder="Select Blood Group"
              styles={selectStyles}
            />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Birth Place
            </label>
            <div className="relative">
              <FaBirthdayCake className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="birth_place"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter birth place"
              />
            </div>
          </div>

          {/* Church Account ID */}
          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Church Account ID
            </label>
            <div className="relative">
              <FaChurch className="absolute text-gray-400 top-3 left-3" />
              <input
                type="text"
                name="church_account_id"
                onChange={handleChange}
                className="w-full p-3 pl-10 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter church account ID"
              />
            </div>
          </div>

          <div className="col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Upload Transfer Certificate / Church Letter
            </label>
            <div className="flex justify-center px-6 pt-5 pb-6 mt-1 border-2 border-gray-300 border-dashed rounded-md">
              <div className="space-y-1 text-center">
                <FaUpload className="w-12 h-12 mx-auto text-gray-400" />
                <div className="flex text-sm text-gray-600">
                  <label
                    htmlFor="file-upload"
                    className="relative font-medium text-blue-600 bg-white rounded-md cursor-pointer hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500"
                  >
                    <span>Upload a file</span>
                    <input
                      id="file-upload"
                      name="certificate_upload"
                      type="file"
                      className="sr-only"
                      onChange={handleImageChange}
                      accept=".jpeg, .jpg, .png, .pdf, .docx"
                    />
                  </label>
                  <p className="pl-1">or drag and drop</p>
                </div>
                <p className="text-xs text-gray-500">
                  PNG, JPG, PDF up to 10MB
                </p>
              </div>
            </div>
          </div>
          {/* Save button at the bottom */}
          <div className="flex justify-center col-span-2 mt-6">
            &nbsp;
            <button
              className="flex items-center px-6 py-3 text-white transition duration-300 ease-in-out bg-blue-600 rounded-md hover:bg-blue-700"
              onClick={handleFamilyRegistration}
              type="button"
            >
              <FaSave className="mr-2" /> Save Family Details
            </button>
          </div>
        </form>
        <div className="flex justify-center mt-2">
          <button
            className="flex items-center px-6 py-3 text-sm text-white transition duration-300 ease-in-out bg-gray-600 rounded-md hover:bg-gray-700"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="mr-2" /> Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default FamilyAddChild;
